import React from 'react';
import DataMenuItem from '../DataMenuItem/DataMenuItem';
import './style.scss';
import { DATASET } from '../../data/DATASET';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Map } from 'immutable';
export default function DataMenuList(props) {

    const getChildrenVisibilityList = (data) => {
        if (data.isChildStatic) {
            const belongingKey = data.childrenList[0].belongingkey;
            return props.childrenData.get(belongingKey).get("visibilities");
        } else {
            return props.childrenData.get(data.id).get("visibilities");
        }
    }
    const isAccordionChecked = (data) => {
        let childrenListItemVisibilityList = getChildrenVisibilityList(data);
        let isChecked = true;
        if (data.isChildStatic) {

            childrenListItemVisibilityList.forEach(function (value, key) {
                isChecked = isChecked && value;
            });
            return isChecked;
        }
        else {
            if (childrenListItemVisibilityList === null) {
                return false
            } else {
                childrenListItemVisibilityList.forEach((visibilityItem) => {
                    isChecked = isChecked && visibilityItem;
                })
            }
            return isChecked;
        }
    }
    const accordionControlChange = (dataMap) => {
        const initialVal = isAccordionChecked(dataMap);
        const belongingKey = dataMap.isChildStatic ? dataMap.childrenList[0].belongingkey : dataMap.id;
        let childrenListItemVisibilityList = getChildrenVisibilityList(dataMap);
        let updatedChildrenVisibilityList = childrenListItemVisibilityList.map(() => {
            return !initialVal
        })
        let childrenDataObject = props.childrenData.toObject();
        let childItemDataObject = childrenDataObject[belongingKey].toObject();
        let _childItemDataObject = {
            ...childItemDataObject,
            "visibilities": updatedChildrenVisibilityList
        }
        let newChildrenMap = new Map(props.childrenData).set(belongingKey, new Map(_childItemDataObject))
        props.setChildrenList(newChildrenMap)
    }
    const getChildrenItems = (data) => {
        if (data.isChildStatic) {//Static Child
            return data.childrenList.map((item) => {
                return <DataMenuItem id={item.index} dataName={item.name} {...item} isChild={true} isChildStatic={true} belongingKey={item.belongingkey} {...props} />
            })
        } else {//Dynamic Child
            if (props.childrenData.get(data.id).get("data") !== null) {
                return props.childrenData.get(data.id).get("data").map((eachData) => {
                    return <DataMenuItem id={eachData.id} dataName={eachData.name} {...eachData} isChild={true} isChildStatic={false} belongingKey={eachData.belongingKey} {...props} />
                })
            }
        }
    }
    return (
        <div className="dataset_list">
            {DATASET.map((data) => {
                if (data.menuItemType === "basic" || data.menuItemType === "advanced") {
                    return <DataMenuItem id={data.id} dataName={data.name} isChild={false} {...props} />
                } else if (data.menuItemType === "accordion") {
                    return (
                        <Accordion className="accordion_menu_item" TransitionProps={{ unmountOnExit: true }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-label="Expand"
                                aria-controls="additional-actions1-content"
                                id="additional-actions1-header"
                            >
                                <FormControlLabel
                                    aria-label="Acknowledge"
                                    onClick={(event) => event.stopPropagation()}
                                    onFocus={(event) => event.stopPropagation()}
                                    control={<Checkbox
                                        checked={isAccordionChecked(data)}
                                        onChange={() => accordionControlChange(data)}
                                    />}
                                    label={data.name}
                                />
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="dataset_list_accordion">
                                    {getChildrenItems(data)}
                                </div>
                            </AccordionDetails>
                        </Accordion>)
                }
            })}
        </div>
    );
}